export default "__VITE_ASSET__DjshTKQX__"